import { Injectable, Injector } from '@angular/core';
import { FormType, OlogNotificationType } from 'src/app/common/enumerations/enumerations';
import { MessagePlaceholder } from 'src/app/common/models/placeholder';
import { FormService } from 'src/app/controls/form-table/form.service';
import { Form } from 'src/app/services/forms/form';
import { OLogService } from 'src/app/components/olog/olog.service';
import { SaveTaskResource, WFTaskSignatureResource, WfSignature, WfSignatureResource } from '../workflow/workflow';
import { KEService } from '../kenable/ke.service';
import { Restriction } from 'src/app/controls/restrictions/services/restriction';
import { Observable, Subscription } from 'rxjs';
import { BaseService } from 'src/app/common/base/base.service';
import { EB2 } from './eb';
import { FormVersion } from 'src/app/services/forms/form-version';
import { IFormService } from 'src/app/common/interfaces/i-form-service';
import { FormBaseV2 } from 'src/app/common/models/model-base';

@Injectable({
  providedIn: 'root'
})
export class EbService extends BaseService<EB2, number> implements IFormService {
  public form!: Form;

  restrictions!: Restriction[];
  restrictionsFiltered!: Restriction[];
  restrictions$!: Observable<Restriction[]>;
  restrictionsSubs!: Subscription;

  constructor(
    protected override injector: Injector,
    private formService: FormService,
    private ologService: OLogService,
    private keService: KEService
  ) {
    super(injector, '/EB');
  }

  setAmendmentRequesters(wfSignatures: WfSignatureResource[]): any {
    return wfSignatures;
  }

  loadRestrictions() {
    this.restrictions$ = this.store.select((state) => state.Restrictions.data);
    this.restrictionsSubs = this.restrictions$.subscribe((data) => {
      if (data?.length) {
        this.restrictions = data;
      }
    });
  }

  async confirmSign(form: Form | FormBaseV2 | null | undefined, task: WfSignature, actionID?: number, data?: any, options?: string) {
    if (!form || !task || !actionID) return false;

    this.form = form as Form;
    const reason = data?.text;
    const formVersion = this.form.formVersion
    this.loadRestrictions();

    const confirmMessage = this.getConfirmMessage(task, formVersion!);

    if (confirmMessage) {
      const confirmed = await this.showDialog(confirmMessage);
      if (!confirmed) return false;
    }

    this.sign(this.form, task.taskId, actionID, reason, options);
    return true;

  }

  private getConfirmMessage(task: WfSignature, formVersion: FormVersion): { message: string, icon: string } | null {
    switch (task.code) {
      case 'BPV':      // Bypass Verifier in Regular Form
      case 'OIC-BPV':  // OIC Bypass Verifier in Regular Form if Not ByPass Details Changed
        if (task.code == 'BPV' || (task.code == 'OIC-BPV' && formVersion.eB2?.bypassDetails == formVersion.previousVersion?.eB2?.bypassDetails))
          return { message: this.getMessage('toActiveWarning').description, icon: "warn" };
        return null;

      default:
        return null;
    };
  }



  private handleKES(restrictedResourceIDs: number[]) {
    if (restrictedResourceIDs?.length) {
      this.keService.processKES(restrictedResourceIDs);
    }
  }

  async sign(form?: Form | null, taskId?: number, actionId?: number, reason?: string, options?: string, amendment?: boolean) {
    if (form?.id && taskId && actionId) {
      this.form = form;
      const restrictedResourceIDs = this.restrictions?.filter(x => this.form?.formVersion?.eB2?.eB2Restrictions?.some(r => r.restrictionID === x.id)).map(y => y.resourceID)?.filter((resourceID): resourceID is number => resourceID !== undefined);
      const formStatus = this.form.formVersion.status;
      const status = formStatus.id;
      const formID = form?.id
      const wfTaskSignature: WFTaskSignatureResource = { taskId, actionId, reason, formID, amendment, options, status };
      const data = await this.formService.sign(wfTaskSignature).toPromise().catch(error => {
        console.error(error);
        this.alert.defaultError();
      });
        if (data && data?.formVersion.statusID != formStatus.id) {
          this.alert.message('formStateChanged', [new MessagePlaceholder("{serialNo}", this.form?.sequenceNumber.number), new MessagePlaceholder('{status}', data.formVersion.status.name)]);
        }
        this.handleKES(restrictedResourceIDs);
      return data;
    }
    else return undefined;
  }

  editOlog(form?: Form | null) {
    this.ologService.editOlog(FormType.EBF, form?.id ?? 0, OlogNotificationType.Activate);
  }

  save(form: Form | FormBaseV2): Promise<FormBaseV2> {
    throw new Error("Method not implemented.");
  }

  saveTask(s: SaveTaskResource): Observable<any> {
    throw new Error('Method not implemented.');
  }

}
